import axios from 'axios'
import router from '@/router'
import store from '@/store/store'
import { responseMessagesHasErrorCode } from '@/util/Util'
import { _ } from 'vue/types/umd'
import get from 'lodash/get'
import has from 'lodash/has'
import auth from '@/auth/authService'

let vs: any
let baseUrl = process.env.VUE_APP_API_BASE_URL

const axiosStandard = axios.create({
  baseURL: baseUrl,
  timeout: 100000,
  withCredentials: true,
  transformResponse: [
    function(data) {
      return data
    }
  ]
})

axiosStandard.interceptors.request.use(
  config => {
    const activeEntity = store.getters['dataAccess/activeEntity']

    loadDataAccess(config, activeEntity)

    config.headers.Authorization = `Bearer ${getToken()}`
    return config
  },
  error => {
    Promise.reject(error)
  }
)

axiosStandard.interceptors.response.use(
  response => {
    store.dispatch('setLastRequest', Date.now())
    const requestUrl = (response.config && response.config.url) || ''
    try {
      require('@/services/SessionTimeoutService').default.notifyApiActivity(requestUrl)
    } catch (activityError) {
      // Evita quebrar a resposta se o serviço ainda não estiver pronto.
    }
    return response
  },
  function(error) {
    if (error.response && error.response.status === 401) {
      let reason = null
      try {
        const data = typeof error.response.data === 'string'
          ? JSON.parse(error.response.data)
          : error.response.data
        reason = data && data.reason
      } catch (parseError) {
        reason = null
      }

      const sessionTimeoutService = require('@/services/SessionTimeoutService').default
      if (sessionTimeoutService.isRedirectingToLogin()) {
        return Promise.reject(error.response)
      }
      if (reason === 'session_timeout' || sessionTimeoutService.isExpiredPromptActive()) {
        sessionTimeoutService.showExpiredPrompt()
        return Promise.reject(error.response)
      }

      localStorage.removeItem('userInfo')
      router.push('/login')
    } else if (error.response && error.response.status === 403) {
      const errorData = JSON.parse(error.response.data)
      showMessage(errorData)
      router.push('/')
    } else if (error.response && error.response.status === 503) {
      //const msgException = JSON.parse(error.response.data)
      //if(msgException && msgException.exception
      //                && msgException.exception.indexOf('MaintenanceModeException') !== -1){
        auth.logOut()
        router.push('/maintenance') // maintenancePage
      //}
    } else if (vs) {
      const errorData = JSON.parse(error.response && error.response.data)
      showMessage(errorData)
    }

    try {
      const errorResponse = (error.response.status === 422) && JSON.parse(error.response.data)
      if(errorResponse && ('code' in errorResponse)) {
        // if (errorResponse.code === 0xBAD10) {
        //   router.push('/first-access')
        // }
      }
    } catch (error) {
      return Promise.reject(error.response)
    }

    return Promise.reject(error.response)
  }
)


function showMessage(errorData: any) {
  if (errorData.messages != undefined) {
    const messages = JSON.parse(errorData.messages)

    messages.forEach((message: any[]) => {
      if (typeof message === 'string' || message instanceof String) {
        vs.notify({
          time: 5000,
          title: 'Alerta',
          text: message,
          iconPack: 'feather',
          icon: 'icon-x-circle',
          color: 'danger',
          position: 'top-center'
        })
      } else {
        message.forEach(element => {
          let icon = 'icon-alert-triangle'
          let title = ''
          let color = 'success'
          let time = 3000
          const fixed = false
          let position = 'bottom-right'
          if (element instanceof String) {
            icon = 'icon-x-circle'
            title = 'Error'
            color = 'danger'
            position = 'top-center'
            time = 5000
          } else {
            switch (element.level) {
              case 'success': {
                icon = 'icon-check-circle'
                title = 'Success'
                color = 'success'
                position = 'bottom-right'
                break
              }
              case 'error': {
                icon = 'icon-x-circle'
                title = 'Error'
                color = 'danger'
                position = 'top-center'
                time = 5000
                break
              }
              case 'warning': {
                icon = 'icon-alert-circle'
                title = 'Warning'
                color = 'warning'
                position = 'bottom-right'
                break
              }
            }
          }

          vs.notify({
            time,
            title,
            text: element.message,
            iconPack: 'feather',
            icon,
            color,
            position
          })
        })
      }
    })
  }
}

function getToken() {
  let token = ''
  token = store.getters.userToken || ''
  return token
}

const standard = {
  axios() {
    return axiosStandard
  },
  token() {
    return getToken()
  },
  setVs(_vs: any) {
    vs = _vs
  },
  setBaseUrl(_baseUrl: any) {
    baseUrl = _baseUrl
  }
}

function loadDataAccess(config, activeEntity) {
  if (has(activeEntity, 'id') && get(activeEntity, 'id') !== -1) {
    config.headers['SCD-Data-Access'] = `${get(activeEntity, 'id')},${get(activeEntity, 'type')}`
  }
}

export default standard
